import { Coupon, ICoupon } from 'src/app/models/coupon.model';
import { IProduct, Product } from 'src/app/models/products.model';
import { IAddress, IDatosPago, IDeliveryNotes, IDeliveryTime, IUserOrder } from 'src/app/pages/cart-detail/cart-detail.model';

export class Concept {

    public id: string;
    public titulo: string;
    public cantidad: number;
    public product_key: string;
    public formato: string;
    public impuesto: number;
    public precio_venta: number;
    public image?: any;
    public base_imponible?: number;
    public importe_iva?: number;
    public descuento?: number;
    public total?: number;
    public total_servido?: number;
    public diferencia?: number;
    public precio_venta_servido?: number;
    public base_imponible_servido?: number;
    public importe_iva_servido?: number;
    public descuento_servido?: number;
    public observaciones: string;
	public formato_servido?: number;


    constructor(obj?: IConcept) {

        this.id = obj && obj.id || null;
        this.titulo = obj && obj.titulo || '';
        this.cantidad = obj && obj.cantidad || 0;
        this.product_key = obj && obj.product_key || '';
        this.impuesto = obj && obj.impuesto || 0;
        this.precio_venta = obj && obj.precio_venta || 0;
        this.base_imponible = obj && obj.base_imponible || 0
        this.total = obj && obj.total || 0;
        this.descuento = obj && obj.descuento || 0;
        this.importe_iva = obj && obj.importe_iva || 0;
        this.formato = obj && obj.formato || '';
        this.image = obj && obj.image || null;
        this.observaciones = obj && obj.observaciones || '';


        if (obj && obj.total_servido) {
            this.total_servido = obj.total_servido;
        }

        if (obj && obj.precio_venta_servido) {
            this.precio_venta_servido = obj.precio_venta_servido;
        }

        if (obj && obj.base_imponible_servido) {
            this.base_imponible_servido = obj.base_imponible_servido;
        }

        if (obj && obj.importe_iva_servido) {
            this.importe_iva_servido = obj.importe_iva_servido;
        }

        if (obj && obj.descuento_servido) {
            this.descuento_servido = obj.descuento_servido;
        }

        if (obj && obj.diferencia) {
            this.diferencia = obj.diferencia;
        }

    }

}

export interface IConcept {
    id: string;
    titulo: string;
    cantidad: number;
    product_key: string;
    formato: string;
    impuesto: number;
    precio_venta: number;
    image?: any;
    base_imponible?: number;
    importe_iva?: number;
    descuento?: number;
    total?: number;
    diferencia?: number;
    formato_servido?: number;
    precio_venta_servido?: number;
    base_imponible_servido?: number;
    importe_iva_servido?: number;
    total_servido?: number;
    descuento_servido?: number;
    observaciones: string;
}


export class Order {

    public numero: string;
    public key?: string;
    public client_uid: string;
    public createdAt: string
    public modifiedAt: string
    public codigo_promocional: string;
	public entrega: string;
	public old_entrega: string;
    public tipo_entrega: string;
	public metodo_pago: string;
    public direccion: IAddress;
    public datos_pago?: IDatosPago;
    public datos_usuario: IUserOrder;
    public commerces?: ICommerceOrder[];
    public gastos_envio?: number;
    public total_compra?: number;
    public total?: number;
    public base_imponible: number;
    public importe_iva: number;
    public coupons: ICoupon[]
    public descuento: number;
    public fecha: string;
    public fecha_recogida: string;
    public llamar: boolean;
    public notas: string;
    public total_pedido: number;
    public estado?: string;
    public place: string;
    public balance: boolean;
    public cantidad_balance: number;
	public multiple: boolean;
    public total_multiple: number;
    public parent: string;

    constructor(obj?: IOrder) {
        this.numero = obj && obj.numero || null;
        this.client_uid = obj && obj.client_uid || null;
        this.createdAt = obj && obj.createdAt || null;
        this.modifiedAt = obj && obj.modifiedAt || null;
        this.codigo_promocional = obj && obj.codigo_promocional || '';
		this.entrega = obj && obj.entrega || null;
		this.old_entrega = obj && obj.old_entrega || null;
        this.tipo_entrega = obj && obj.tipo_entrega || TypeOrder.ENVIO_DOMICILIO;
		this.metodo_pago = obj && obj.metodo_pago || PaymentMethod.TARJETA;
        this.direccion = obj && obj.direccion || null;
        this.datos_pago = obj && obj.datos_pago || null;
        this.datos_usuario = obj && obj.datos_usuario || null;
        this.gastos_envio = (obj && obj.gastos_envio) || (this.tipo_entrega === TypeOrder.ENVIO_DOMICILIO) ? 2.95 : 0;
        this.total_compra = obj && obj.total_compra || 0;
        this.base_imponible = obj && obj.base_imponible || 0;
        this.importe_iva = obj && obj.importe_iva || 0;
        this.commerces = obj && obj.commerces || [];
        this.coupons = obj && obj.coupons || [];
        this.total = obj && obj.total || 0;
        this.descuento = obj && obj.descuento || 0;
        this.fecha = obj && obj.fecha || '';
        this.fecha_recogida = obj && obj.fecha_recogida || '';
        this.place = obj && obj.place || '';
        this.llamar = obj && obj.llamar || false;
        this.notas = obj && obj.notas || '';
        this.total_pedido = obj && obj.total_pedido || 0;
        this.estado = obj && obj.estado || StateOrder.PENDIENTE_3D_SECURE;
        this.balance = obj && obj.balance || false;
        this.cantidad_balance = obj && obj.cantidad_balance || 0;
		this.multiple = obj && obj.multiple || false;
        this.total_multiple = obj && obj.total_multiple || 0;
        this.parent = obj && obj.parent || null;

        if (obj && obj.key) {
            this.key = obj.key;
        }
        // this.total = ((obj && obj.total_compra) ? obj.total_compra + this.gastos_envio : 0);
    }

}


export interface IOrder {
    numero?: string;
    client_uid: string;
    createdAt?: string
    modifiedAt?: string
    codigo_promocional?: string;
	entrega?: string;
	old_entrega?: string;
    tipo_entrega?: string;
	metodo_pago: string;
    direccion: IAddress
    datos_pago?: IDatosPago;
    datos_usuario: IUserOrder;
    commerces?: ICommerceOrder[];
    gastos_envio?: number;
    total_compra?: number;
    base_imponible: number;
    importe_iva: number;
    total?: number;
    coupons: ICoupon[],
    descuento: number;
    fecha: string;
    fecha_recogida: string;
    llamar: boolean;
    notas: string;
    total_pedido: number;
    estado?: string;
    available_for_purchase?: boolean;
    place: string;
    key?: string;
    balance: boolean;
    cantidad_balance: number;
	multiple: boolean;
    total_multiple: number;
	parent?: string;

}

export class CommerceOrder {

    public id?: string;
    public numero?: string;
    public cliente?: string;
    public commerce_key: string;
    public nombre_comercio: string;
    public order_key: string;
    public conceptos: Concept[];
    public open?: boolean;
    public base_imponible: number;
    public importe_iva: number;
    public total: number;
    public descuento?: number;
    public pedido_minimo?: number;
    public pedido_diferencia?: number;
    public email_comercio: string;
    public fecha_recogida: string;
    public datos_usuario?: any;
    public tipo_entrega?: string;
    public fecha?: string;
    public estado?: string;
    public precio_venta_servido?: number;
    public base_imponible_servido?: number;
    public importe_iva_servido?: number;
    public total_servido?: number;
    public descuento_servido?: number;
    public coupons?: Coupon[]

    constructor(obj?: ICommerceOrder) {

        this.id = obj && obj.id || '';
        this.open = obj && obj.open || false;
        this.commerce_key = obj && obj.commerce_key || '';
        this.email_comercio = obj && obj.email_comercio || '';
        this.order_key = obj && obj.order_key || '';
        this.conceptos = obj && obj.conceptos || [];
        this.base_imponible = obj.base_imponible && obj.base_imponible || 0;
        this.importe_iva = obj.importe_iva && obj.importe_iva || 0;
        this.total = obj.total && obj.total || 0;
        this.descuento = obj && obj.descuento || 0;
        this.fecha_recogida = obj && obj.fecha_recogida || null;
        this.estado = obj && obj.estado || StateOrder.PREPARACION;

        if (obj && obj.pedido_minimo) {
            this.pedido_minimo = obj.pedido_minimo;
        }

        if (obj && obj.pedido_diferencia) {
            this.pedido_diferencia = obj.pedido_diferencia;
        }

        if (obj && obj.numero) {
            this.numero = obj.numero;
        }

        if (obj && obj.cliente) {
            this.cliente = obj.cliente;
        }

        if (obj && obj.datos_usuario) {
            this.datos_usuario = obj.datos_usuario;
        }

        if (obj && obj.tipo_entrega) {
            this.tipo_entrega = obj.tipo_entrega;
        }

        if (obj && obj.fecha) {
            this.fecha = obj.fecha;
        }

        if (obj && obj.total_servido) {
            this.total_servido = obj.total_servido;
        }

        if (obj && obj.precio_venta_servido) {
            this.precio_venta_servido = obj.precio_venta_servido;
        }

        if (obj && obj.base_imponible_servido) {
            this.base_imponible_servido = obj.base_imponible_servido;
        }

        if (obj && obj.importe_iva_servido) {
            this.importe_iva_servido = obj.importe_iva_servido;
        }

        if (obj && obj.importe_iva_servido) {
            this.descuento_servido = obj.descuento_servido;
        }

        if (obj && obj.coupons) {
            this.coupons = obj.coupons;
        }
    }

}



export interface ICommerceOrder {
    id?: string;
    numero?: string;
    cliente?: string;
    commerce_key: string;
    order_key?: string;
    createdAt?: string
    modifiedAt?: string
    nombre_comercio: string;
    horario: any[];
    conceptos: Concept[];
    open?: boolean;
    base_imponible: number;
    importe_iva: number;
    total: number;
    descuento?: number;
    pedido_minimo?: number;
    pedido_diferencia?: number;
    email_comercio: string;
    fecha_recogida: string;
    datos_usuario?: any;
    tipo_entrega?: string;
    fecha?: string;
    key?: string;
    estado?: string;
    precio_venta_servido?: number;
    base_imponible_servido?: number;
    importe_iva_servido?: number;
    total_servido?: number;
    descuento_servido?: number;
    coupons?: Coupon[]
}


export class CommerceProduct extends Product {

    public cantidad: number;
    public titulo_categoria: string;
    public media: any[];

    constructor(obj) {
        super(obj);

        this.cantidad = obj && obj.cantidad || 0;
        this.titulo_categoria = obj && obj.titulo_categoria || 0;
        this.media = obj && obj.media || [];

    }
}

export interface ICommerceProduct extends IProduct {
    cantidad: number;
    titulo_categoria: string;
    media: any[];

}

export class TypeOrder {

    public static readonly ENVIO_DOMICILIO = 'ENVIO_DOMICILIO';
    public static readonly RECOGIDA_TIENDA = 'RECOGIDA_TIENDA';

}
export class PaymentMethod {

    public static readonly TARJETA = 'TARJETA';
	public static readonly BIZUM = 'BIZUM';
    public static readonly EFECTIVO = 'EFECTIVO';



}
export class StateOrder {
    public static readonly PENDIENTE_3D_SECURE = 'PENDIENTE_3D_SECURE';
    public static readonly PREPARACION = 'PREPARACION';
    public static readonly COMPLETADO = 'COMPLETADO';
    public static readonly FINALIZADO = 'FINALIZADO';
    public static readonly ENTREGADO = 'ENTREGADO';
}
